import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';

import { download } from '../../../lib/file';
import { stackupLayerPropType, calculationsShape } from '../../../lib/shapes';
import { FILE_EXTENSION } from '../../../constants/globals';

export class ExportingDialog extends React.Component {
  constructor(props) {
    super(props);
    const { title } = props;
    this.handleDownload = this.handleDownload.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      filename: title
    }
  }

  handleDownload() {
    const { handleClose, stackup, calculations } = this.props;
    const { filename } = this.state;
    download(filename, { stackup, calculations });
    
    handleClose();
  }

  handleChange(prop) {
    const that = this;
    return event => {
      that.setState({ [prop]: event.target.value });
    };
  }

  render() {
    const { fullScreen, open, handleClose, stackup } = this.props;
    const { layers } = stackup;
    const { filename } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Export Current Stakcup Configuration to a file
        </DialogTitle>
        {layers.length > 0 ? (
          <DialogContent>
            <DialogContentText>
              You can download the current stackup configuration to restore later.
            </DialogContentText>
            <FormControl fullWidth>
              <InputLabel htmlFor="filename">Filename</InputLabel>
              <Input
                id="filename"
                autoFocus
                autoComplete="off"
                margin="dense"
                type="text"
                value={filename}
                onChange={this.handleChange('filename')}
                endAdornment={(
                  <InputAdornment position="end">
                    {FILE_EXTENSION}
                  </InputAdornment>
                )}
              />
            </FormControl>
          </DialogContent>
        ) : (
          <DialogContent>
            <DialogContentText>
              You don&apos;t have any stackup to download at this time.
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Close 
          </Button>
          {layers.length > 0 ? (
            <Button
              onClick={this.handleDownload}
              color="primary"
              autoFocus
              variant="raised"
              disabled={filename === ''}
            >
              Download 
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
    );
  }
}

ExportingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  stackup: PropTypes.shape({
    name: PropTypes.string,
    partNumber: PropTypes.string,
    type: PropTypes.string,
    layers: PropTypes.arrayOf(PropTypes.shape(stackupLayerPropType))
  }).isRequired,
  calculations: PropTypes.shape(calculationsShape).isRequired
};

export default withMobileDialog()(ExportingDialog);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/ExportingDialog/ExportingDialog.jsx